module.exports = __webpack_public_path__ + "img/lianyi.e45cc4fe.png";